// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InternalIds
 */
export interface InternalIds {
  /**
   *
   */
  layerId: string;
  /**
   *
   */
  sourceId: string;
  /**
   *
   */
  wmsLayer: string;
}

/**
 * Check if a given object implements the InternalIds interface.
 */
export function instanceOfInternalIds(value: object): value is InternalIds {
  if (
    (!("layerId" in (value as Record<string, any>)) &&
      !("layer_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["layerId"] === undefined &&
      (value as Record<string, any>)["layer_id"] === undefined)
  )
    return false;
  if (
    (!("sourceId" in (value as Record<string, any>)) &&
      !("source_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["sourceId"] === undefined &&
      (value as Record<string, any>)["source_id"] === undefined)
  )
    return false;
  if (
    (!("wmsLayer" in (value as Record<string, any>)) &&
      !("wms_layer" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["wmsLayer"] === undefined &&
      (value as Record<string, any>)["wms_layer"] === undefined)
  )
    return false;
  return true;
}

export function InternalIdsFromJSON(json: any): InternalIds {
  return InternalIdsFromJSONTyped(json, false);
}

export function InternalIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalIds {
  if (json == null) {
    return json;
  }
  return {
    layerId: json["layer_id"],
    sourceId: json["source_id"],
    wmsLayer: json["wms_layer"],
  };
}

export function InternalIdsToJSON(json: any): InternalIds {
  return InternalIdsToJSONTyped(json, false);
}

export function InternalIdsToJSONTyped(
  value?: InternalIds | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    layer_id: value["layerId"],
    source_id: value["sourceId"],
    wms_layer: value["wmsLayer"],
  };
}
